import Api from "@/services/Api";

export default {
  getCoupon(id?: string) {
    if (typeof id === "undefined") {
      return Api().get(`/coupon/get_coupon`);
    }
    return Api().get(`/coupon/get_coupon?coupon_id=${id}`);
  }
};
